import { ErrorBoundary } from "@sentry/react";
import * as React from "react";
import { useContext, useMemo } from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import { ErrorMsg, NoDataMsg } from "../../../../components/AppMessages";
import SegmentVolumeChart from "../../../../components/Charts/BrandPerformance/SegmentVolumeChart";
import LoadingEllipsis from "../../../../components/Loading/LoadingEllipsis";
// import BrandPerformanceTable from "../../../../components/Tables/BrandPerformanceTable";
import { performancePages } from "../../../../constants";
import { ThemeContext } from "../../../../context";
import PmoTooltip from "../../../ProductMarketingOptimization/components/common/PmoTooltip";
import CompetitorSelect from "../competitorSelect";

interface Props {
  chartData: any;
  TooltipParagraphs?: () => JSX.Element;
  TooltipParagraphAvg?: () => JSX.Element;
  trendTitle: string;
  trendChartId: string;
  loadingTrend: boolean;
  percentageChart?: boolean;
  activePage: performancePages;
  diff: number;
  chartGranularity?: string;
}

const SegmentVolumeSection = (props: Props) => {
  const { theme } = useContext(ThemeContext);
  const { granularity, date_range, market } = useSelector((state: RootStateOrAny) => state.parameters);

  const {
    chartData,
    TooltipParagraphs,
    TooltipParagraphAvg,
    trendTitle,
    trendChartId,
    loadingTrend,
    percentageChart,
    activePage,
    diff,
    chartGranularity,
  } = props;

  const topModels = useMemo(() => {
    return chartData?.series?.slice(-10)?.map((series: { name: any }) => series?.name);
  }, [chartData]);

  return (
    <>
      <div className="primary_background ">
        <div className="header" style={{ paddingTop: "1em", paddingLeft: "1em" }}>
          <div className="title_container">
            <h3>{trendTitle}</h3>
            {TooltipParagraphs && <PmoTooltip paragraphs={<TooltipParagraphs />} />}
          </div>
        </div>
        <div className="chart_content">
          {chartData?.data?.length && !loadingTrend ? (
            <ErrorBoundary fallback={<ErrorMsg />}>
              <SegmentVolumeChart
                theme={theme}
                chartId={trendChartId}
                granularity={chartGranularity ? chartGranularity : granularity}
                seriesList={chartData.series?.map((val: any, idx: number) => ({ ...val, hide: !topModels?.includes(val?.name) }))}
                data={chartData.data}
                percentageChart={percentageChart}
                market={market}
                diff={diff}
              />
            </ErrorBoundary>
          ) : loadingTrend ? (
            <LoadingEllipsis isLoading={loadingTrend} />
          ) : (
            <NoDataMsg message="No data available" />
          )}
        </div>
      </div>
    </>
  );
};

export default SegmentVolumeSection;
